/* eslint-disable react/require-default-props */
import React from 'react';
import InputCommon from '../inputCommon';
import icons from '../../constants/icons';
import {
  RowInput,
  Info,
  Img,
  ContainerIcon,
  Column,
  OnPress,
  Row,
} from './styles';

interface Props {
  id: string;
  isError?: boolean;
  from: string;
  to: string;
  end: string;
  onChangeFrom: Function;
  onChangeTo: Function;
  onChangeEnd: Function;
  remove: Function;
  firstText?: string;
  secontText?: string;
  endText?: string;
}

const RowInputCustom: React.FC<Props> = ({
  from,
  to,
  end,
  onChangeFrom,
  onChangeTo,
  onChangeEnd,
  remove,
  id,
  isError,
  firstText,
  secontText,
  endText,
}) => (
  <RowInput key={id}>
    <Row>
      <InputCommon
        isDisabled={false}
        isError={isError || false}
        type="number"
        placeholder=""
        value={from}
        onChange={(value: string) => {
          onChangeFrom(value, id);
        }}
      />
      <Info>{firstText || 'Até'}</Info>
      <InputCommon
        isDisabled={false}
        isError={isError || false}
        type="number"
        placeholder=""
        value={to}
        onChange={(value: string) => {
          onChangeTo(value, id);
        }}
      />
      <Info>{secontText || 'Receberá'}</Info>
      <InputCommon
        isDisabled={false}
        isError={isError || false}
        type="number"
        placeholder=""
        value={end}
        onChange={(value: string) => {
          onChangeEnd(value, id);
        }}
      />
      <Info>{endText || 'Posições'}</Info>
    </Row>
    <OnPress onClick={() => {
      remove(id);
    }}
    >
      <Column>
        <ContainerIcon>
          <Img width={11} style={{ marginRight: 2 }} src={icons.trashIcon} />
        </ContainerIcon>
      </Column>
    </OnPress>
  </RowInput>
);
export default RowInputCustom;
